import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Utils from "../../scripts/Utils";
import axios from "axios";
import Vue from "vue";

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    data: null,
    zoneDetails: null,          //current zone details
    selectedZone: null,
    cancelToken: {
        createZone: null,
        deleteZone: null,
        createPosition: null,
        editPosition: null,
        deletePosition: null,
    }
};

// getters
const getters = {
    positions(state, getters, rootState) {
        let ret = [];
        if (state.zoneDetails) {
            for (let position in state.zoneDetails.Position) {
                let tmp = JSON.parse(JSON.stringify(state.zoneDetails.Position[position]));
                tmp.name = position;
                tmp.action = ['edit'];
                if (rootState.readOnly === 0 && rootState.route.meta.editRights.includes(rootState.users.role) && state.zoneDetails.Zone.Name !== '_default' && !tmp.Override) tmp.action.push('reset')
                if (rootState.readOnly === 0 && rootState.route.meta.editRights.includes(rootState.users.role) && (state.zoneDetails.Zone.Name === '_default' || (state.zoneDetails.Zone.Oop === 0 && state.zoneDetails.Zone.Interstitial === 0))) tmp.action.push('delete')
                tmp.sizes = stringifySizes(tmp.Sizes);
                tmp.created_at = Utils.formatDate(tmp.Created);
                ret.push(tmp);
            }
        }
        return ret;
    }
};

// actions
const actions = {
    async fetchData({commit}, payload) {
        let {data} = await ServiceRepository.getPositions(payload)
        if (data.Status) {
            commit('setData', {data: data});
        }
    },
    async fetchZoneDetails({commit}, payload) {
        let {data} = await ServiceRepository.getZoneDetails(payload)
        if (data.Status) {
            commit('setZoneDetails', data);
        }
        return data;
    },
    async createZone({dispatch, rootState}, payload) {
        state.cancelToken.createZone = axios.CancelToken.source();
        let {data} = await ServiceRepository.createZone(payload, state.cancelToken.createZone.token);
        if (data.Status) {
            rootState.display.siteDetails.Zones = data.Zones;
            let createdZone = data.Zones.find(x => Utils.parseZoneName(x.Name) === payload.Name);
            dispatch('fetchZoneDetails', createdZone.ZoneId);
        }
        return data;
    },
    async deleteZone({state, rootState}, payload) {
        state.cancelToken.deleteZone = axios.CancelToken.source();
        let {data} = await ServiceRepository.deleteZone(payload, state.cancelToken.deleteZone.token);
        if (data.Status) {
            rootState.display.siteDetails.Zones = data.Zones;
            if (state.zoneDetails && state.zoneDetails.Zone.ZoneId === payload.zone_id) state.zoneDetails = null;
        }
        return data;
    },
    async createPosition({state}, payload) {
        state.cancelToken.createPosition = axios.CancelToken.source();
        let {data} = await ServiceRepository.createPosition(payload, state.cancelToken.createPosition.token);
        if (data.Status) {
            state.zoneDetails.Position = data.Position;
        }
        return data;
    },
    async editPosition({state}, payload) {
        state.cancelToken.editPosition = axios.CancelToken.source();
        let {data} = await ServiceRepository.editPosition(payload, state.cancelToken.editPosition.token);
        if (data.Status) {
            state.zoneDetails.Position = data.Position;
        }
        return data;
    },
    async savePositionToAll(context, payload) {
        let {data} = await ServiceRepository.savePositionToAll(payload);
        return data;
    },
    async deletePosition({state}, payload) {
        state.cancelToken.deletePosition = axios.CancelToken.source();
        let {data} = await ServiceRepository.deletePosition(payload, state.cancelToken.deletePosition.token);
        if (data.Status) {
            state.zoneDetails.Position = data.Position;
        }
        return data;
    },
    async resetPosition({state, dispatch}, payload) {
        let {data} = await ServiceRepository.resetPosition(payload);
        if (data.Status) {
            state.zoneDetails.Position = data.Position;
            dispatch('fetchZoneDetails', payload.zone_id);
        }
        return data;
    },
};

// mutations
const mutations = {
    setData(state, {data}) {
        state.data = data;
    },
    setSelectedZone(state, data) {
        state.selectedZone = data;
        if (data === null) state.zoneDetails = null;
    },
    setZoneDetails(state, data) {
        state.zoneDetails = data;
    },
    setOopIntNote(state, data) {
        let tmp = JSON.parse(JSON.stringify(state.zoneDetails.Zone));
        tmp.Oop = data.Oop;
        tmp.Interstitial = data.Interstitial;
        //tmp.Note = data.Note;
        Vue.set(state.zoneDetails, 'Zone', tmp);
    },
    cancelRequest(state, data) {//data = name of token
        state.cancelToken[data].cancel();
        state.cancelToken[data] = null;
    },
};

function stringifySizes(sizes) {
    let ret = [];
    sizes.forEach((size) => {
        if (size.Text && size.Text !== "") {
            ret.push(size.Text);
        } else {
            ret.push(size.Width + 'x' + size.Height);
        }
    });
    return ret.join(', ');
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}